'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _themes = require('../themes'),
    _propTypes3 = require('../propTypes'),
    _componentTheme = require('./componentTheme'),
    _componentTheme2 = _interopRequireDefault(_componentTheme);

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Styled = {
  div: {}
};
Styled.div.root = _styledComponents2.default.div.withConfig({
  displayName: 'Card__root'
})(['display:inline-block;padding:', ';overflow:hidden;background-color:', ';border-color:', ';border-width:', ';border-style:', ';border-radius:', ';box-shadow:', ';transition-property:none;transition-duration:', ';transition-timing-function:', ';&:hover{box-shadow:', ';}@media print{border:1px solid black;box-shadow:none;}'], (0, _themes.getStyle)('Card_padding'), (0, _themes.getStyle)('Card_backgroundColor'), (0, _themes.getStyle)('Card_borderColor'), (0, _themes.getStyle)('Card_borderWidth'), function (_ref) {
  var sc = _ref.sc;
  return sc.raised ? (0, _themes.getStyle)('Card_borderStyle_raised') : (0, _themes.getStyle)('Card_borderStyle');
}, (0, _themes.getStyle)('Card_borderRadius'), function (_ref2) {
  var sc = _ref2.sc;
  return sc.raised ? (0, _themes.getStyle)('Card_boxShadow_raised') : (0, _themes.getStyle)('Card_boxShadow');
}, function (props) {
  return props.theme.vstui.transition.duration.shortest;
}, function (props) {
  return props.theme.vstui.transition.easing.easeIn;
}, function (_ref3) {
  var sc = _ref3.sc;
  return sc.raised && sc.interactive ? (0, _themes.getStyle)('Card_boxShadow_raisedInteractive_hover') : sc.raised ? (0, _themes.getStyle)('Card_boxShadow_raised_hover') : (0, _themes.getStyle)('Card_boxShadow_hover');
});

var Card = function (_PureComponent) {
  function Card() {
    return _classCallCheck(this, Card), _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));
  }

  return _inherits(Card, _PureComponent), _createClass(Card, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          interactive = _props.interactive,
          raised = _props.raised,
          themeProp = _props.theme,
          otherProps = _objectWithoutProperties(_props, ['className', 'interactive', 'raised', 'theme']),
          theme = (0, _componentTheme2.default)(themeProp);

      return _react2.default.createElement(Styled.div.root, _extends({}, otherProps, {
        className: className,
        sc: {
          interactive: interactive,
          raised: raised
        },
        theme: theme
      }));
    }
  }]), Card;
}(_react.PureComponent);

Card.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  interactive: _propTypes2.default.bool,
  raised: _propTypes2.default.bool,
  theme: _propTypes3.themeShape
}, Card.defaultProps = {
  theme: (0, _themes.createTheme)()
}, Card.displayName = 'Card';
var CardWithTheme = (0, _themes.withTheme)(Card);
CardWithTheme.WrappedComponent = Card, exports.default = CardWithTheme;